import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailEmploymentsProps as Props } from './types';
import { getCompanyEmployments } from '../../../services/companies';

export const Component: FunctionComponent<Props> = (props) => {
  const [recruitmentEmploymentIds, setRecruitmentEmploymentIds] = useState<number[]>([]);

  useEffect(() => {
    const fetchEmployments = async () => {
      try {
        const response = await getCompanyEmployments(props.company.id);
        setRecruitmentEmploymentIds(response.recruitmentEmploymentIds ?? []);
      } catch (error) {
        console.log(error);
      }
    };
    fetchEmployments();
  }, [props.company.id]);

  return (
    <Presentation
      companyId={props.company.id}
      recruitmentEmploymentIds={recruitmentEmploymentIds}
      dataCategory={props.dataCategory}
      dataValue={props.dataValue}
      employmentRef={props.employmentRef}
    />
  );
};
